import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./SellerNavbar.css";
import logo from "../Assets/images/logo.png";
import {
  LayoutDashboard,
  Package,
  PackagePlus,
  ClipboardList,
  Settings,
  Power,
  Menu,
  X,
} from "lucide-react";
import { useStateValue } from "../../StateProvider";
import { account } from "../../appwrite";

const NAV = [
  { label: "Dashboard", path: "/", icon: LayoutDashboard },
  { label: "My Vault", path: "/s/my-vault", icon: Package },
  { label: "Add Product", path: "/s/add-product", icon: PackagePlus },
  { label: "Orders", path: "/s/orders", icon: ClipboardList },
  { label: "Settings", path: "/s/settings", icon: Settings },
];

export default function SellerNavbar() {
  const [{ user }, dispatch] = useStateValue();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSignOut = async () => {
    try {
      await account.deleteSession("current");
    } catch {}
    dispatch({ type: "SET_USER", user: null });
    navigate("/login");
  };

  const firstName = user
    ? (user.name || user.email || "Seller").split(" ")[0]
    : "S";

  return (
    <nav className="seller-nav">
      <div className="seller-nav__inner">
        {/* Logo */}
        <a href="/" className="seller-nav__logo-link">
          <img src={logo} alt="TrendBay" className="seller-nav__logo" />
          <span className="seller-nav__badge">Seller</span>
        </a>

        {/* Links (desktop) */}
        <div className="seller-nav__links">
          {NAV.map(({ label, path, icon: Icon }) => (
            <Link
              key={path}
              to={path}
              className={`seller-nav__link ${location.pathname === path ? "seller-nav__link--active" : ""}`}
            >
              <Icon size={15} />
              {label}
            </Link>
          ))}
        </div>

        {/* Right: avatar + power */}
        <div className="seller-nav__right">
          <button
            className="seller-nav__power"
            onClick={handleSignOut}
            title="Sign out"
          >
            <Power size={16} />
          </button>

          {/* Hamburger (mobile only) */}
          <button
            className="seller-nav__hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            {menuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      {menuOpen && (
        <div
          className="seller-nav__drawer-backdrop"
          onClick={() => setMenuOpen(false)}
        >
          <div
            className="seller-nav__drawer"
            onClick={(e) => e.stopPropagation()}
          >
            {NAV.map(({ label, path, icon: Icon }) => (
              <Link
                key={path}
                to={path}
                className={`seller-nav__drawer-link ${location.pathname === path ? "seller-nav__drawer-link--active" : ""}`}
                onClick={() => setMenuOpen(false)}
              >
                <Icon size={18} />
                {label}
              </Link>
            ))}
            <div className="seller-nav__drawer-divider" />
            <button
              className="seller-nav__drawer-signout"
              onClick={() => {
                handleSignOut();
                setMenuOpen(false);
              }}
            >
              <Power size={18} />
              Sign Out
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
